export enum MaxFileSize {
  File50MB = 52428800,
  File25MB = 26214400,
  File15MB = 15728640,
}

export const validateMaxFileSize = (file: File, maxFileSize: MaxFileSize): boolean =>
  file.size <= maxFileSize;

export const getHumanReadableFileSize = (bytes: number): string => {
  if (bytes === 0) {
    return '0.00 B';
  }

  const e = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, e)).toFixed(2)} ${'\u200bKMGTP'.charAt(e)}B`;
};
